var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-mb-4 tw-space-y-4"},[_c('LeaveDayDetails',{attrs:{"day-overlap":_vm.dayOverlap,"multiline":false,"no-overlaps-text":"Nobody on leave"},on:{"show-overlap-leave-details":leaveKey => _vm.$emit('show-overlap-leave-details', leaveKey)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }